import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const checkoutMetric = z.object({
  title: z.string(),
  valuesByTreatment: z.array(
    z.object({
      treatmentId: zExt.objectId(),
      value: z.string(),
      highlightMetric: z.boolean().optional(),
    }),
  ),
});
export type CheckoutMetric = z.infer<typeof checkoutMetric>;

export const getAllCheckoutSplitMetrics = {
  name: "getAllCheckoutSplitMetrics" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({
    allTreatmentIds: z.array(zExt.objectId()),
    checkoutMetrics: z.array(checkoutMetric),
  }),
};
